<template>
  <div>
    <Modal
      v-model="address"
      width="560"
      ref="address"
      @on-visible-change="visible"
    >
      <div slot="header">
        <span>{{ text ? '新增' : '修改' }}地址</span>
      </div>
      <div>
        <Form
          label-position="left"
          ref="addressformItems"
          :model="addressformItem"
          :label-width="100"
          :rules="ruleValidate"
        >
          <Form-item label="姓名：" prop="name">
            <Input
              v-model="addressformItem.name"
              placeholder="请输入收货人姓名"
            ></Input>
          </Form-item>
          <Form-item label="电话：" prop="phone">
            <Input
              v-model="addressformItem.phone"
              placeholder="请输入收货人电话"
            ></Input>
          </Form-item>

          <Row>
            <Col span="7">
              <Form-item label="所在地区：" prop="provinceId">
                <Select
                  v-model="addressformItem.provinceId"
                  style="width: 120px"
                  placeholder="省份"
                  @on-change="changeProvince"
                >
                  <Option
                    v-for="item in cityList"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </Form-item>
            </Col>
            <Col span="7" style="text-align: center">
              <Form-item prop="cityId">
                <Select
                  v-model="addressformItem.cityId"
                  style="width: 120px"
                  placeholder="城市"
                  @on-change="changeCity"
                >
                  <Option
                    v-for="item in city"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </Form-item>
            </Col>
            <Col span="7">
              <Form-item prop="countyId">
                <Select
                  v-model="addressformItem.countyId"
                  style="width: 120px"
                  placeholder="区/县"
                  @on-change="changeArea"
                >
                  <Option
                    v-for="item in area"
                    :value="item.id"
                    :key="item.id"
                    >{{ item.name }}</Option
                  >
                </Select>
              </Form-item>
            </Col>
          </Row>

          <Form-item label="详细地址：" prop="detail">
            <Input
              v-model="addressformItem.detail"
              :maxlength="100"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              placeholder="请输入收货人地址"
            ></Input>
          </Form-item>
          <Form-item label="" width="200">
            <Checkbox v-model="addressformItem.preferred">
              &nbsp;设为默认地址</Checkbox
            >
          </Form-item>
        </Form>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="confirmFuzhu" class="mr10">确定</Button>
        <Button type="default" @click="address = false">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { addressGet } from '@/api/orderInformation/addAddress'
import { addressPost } from '@/api/orderInformation/addAddress'
export default {
  // props:{rows},
  data() {
    //校验手机号
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('手机号格式不正确'))
      } else {
        callback()
      }
    }
    return {
      text: true,
      address: false,
      addressformItem: {
        phone: '',
        detail: '',
        name: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        preferred: false,
        accountId: this.$store.state.user.userData.id
      },
      ruleValidate: {
        name: [{ required: true, message: '姓名不能为空', trigger: 'blur' }],
        detail: [
          { required: true, message: '请输入详细地址', trigger: 'blur' }
        ],
        phone: [{ required: true, validator: validatePhone, trigger: 'blur' }],
        provinceId: [{ required: true, message: '请填写', trigger: 'blur' }],
        cityId: [{ required: true, message: '请填写', trigger: 'blur' }],
        countyId: [{ required: true, message: '请填写', trigger: 'blur' }]
      },
      // 地址信息
      addressList: [],
      // 省信息
      cityList: [],
      // 城市信息
      city: [],
      // 区信息
      area: []
    }
  },
  created() {
    this.addressGet()
  },
  methods: {
    //  保存
    async confirmFuzhu() {
      this.$refs.addressformItems.validate(async (value) => {
        if (value) {
          let params = {}
          let data = JSON.parse(JSON.stringify(this.addressformItem))
          data.preferred = Number(this.addressformItem.preferred)
          let res = await addressPost(params, data)
          if (res.status) {
            this.$Message.success('保存成功')
            this.address = false
            this.kong()
            this.$emit('throwName', {})
          } else {
            this.$Message.error('添加失败')
          }
        } else {
          this.$Message.error('验证失败')
        }
      })
    },

    visible() {
      // this.kong()
    },
    // 清空表单
    kong() {
      this.text = true
      this.addressformItem = {
        phone: '',
        detail: '',
        name: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        preferred: false,
        accountId: this.$store.state.user.userData.id
      }
      this.$refs.addressformItems.resetFields()
    },
    // 地址接口
    async addressGet() {
      let res = await addressGet()
      if (res.status) {
        this.addressList = res.data
        this.cityList = res.data.province
      }
    },
    // 省
    changeProvince(value) {
      this.addressformItem.cityId = ''
      this.addressformItem.countyId = ''
      this.city = this.addressList[value]
      this.addressformItem.provinceId = value
    },
    // 市
    changeCity(value) {
      this.area = this.addressList[value]
      this.addressformItem.cityId = value
    },
    // 区
    changeArea(value) {
      this.addressformItem.countyId = value
    },
    // Echo
    echo(row) {
      this.text = false
      this.changeProvinces(row.provinceId)
      this.changeCitys(row.cityId)
      row.preferred = Boolean(row.preferred)
      this.addressformItem = row
      this.address = true
    },
    changeProvinces(value) {
      this.city = this.addressList[value]
      this.addressformItem.provinceId = value
    },
    changeCitys(value) {
      this.area = this.addressList[value]
      this.addressformItem.cityId = value
    }
  }
}
</script>

<style lang="less" scoped>
.mr10 {
  margin-right: 50px;
}
</style>
